
import { TranslationsByLanguage } from './types';

export type FooterTranslationKey =
  | 'footer.rights'
  | 'footer.terms'
  | 'footer.privacy'
  | 'footer.contact'
  | 'footer.legalNotice';

export const footerTranslations: TranslationsByLanguage = {
  en: {
    'footer.rights': 'All Rights Reserved',
    'footer.terms': 'Terms of Service',
    'footer.privacy': 'Privacy Policy',
    'footer.contact': 'Contact Us',
    'footer.legalNotice': 'Legal Notice',
  },
  fr: {
    'footer.rights': 'Tous Droits Réservés',
    'footer.terms': 'Conditions d\'Utilisation',
    'footer.privacy': 'Politique de Confidentialité',
    'footer.contact': 'Nous Contacter',
    'footer.legalNotice': 'Mentions Légales',
  }
};
